import { fulfillmentLabel, orderStatusLabel } from './orderPresentation';

export const SELLER_ORDER_FILTERS = [
  { key: 'all', label: 'Все' },
  { key: 'new', label: 'Новые' },
  { key: 'processing', label: 'В обработке' },
  { key: 'collected', label: 'Собраны' },
  { key: 'shipped', label: 'Отправлены' },
  { key: 'completed', label: 'Завершены' },
  { key: 'cancelled', label: 'Отменены' },
];

export function sellerOrderId(order) { return order?.id; }
export function customerOrderId(order) { return order?.customerOrderId || order?.customer_order_id; }
export function sellerOrderItems(order) { return order?.items || []; }
export function sellerItemTitle(item) { return item?.product_title || item?.productTitle || item?.title || 'Товар'; }
export function sellerItemVariant(item) { return item?.variant_size || item?.variantSize || item?.variant?.size || item?.variant?.name; }
export function sellerItemPrice(item) { return Number(item?.price ?? item?.unitPrice ?? 0); }
export function sellerItemQuantity(item) { return Number(item?.quantity || 1); }
export function sellerOrderAmount(order) {
  return Number(order?.amount ?? order?.sellerAmount ?? sellerOrderItems(order).reduce((sum, item) => sum + sellerItemPrice(item) * sellerItemQuantity(item), 0));
}
export function sellerOrderFulfillment(order) { return order?.fulfillmentStatus || order?.fulfillment_status || null; }
export function sellerOrderStatus(order) { return order?.status || 'UNKNOWN'; }
export function sellerOrderDate(order) {
  const value = order?.createdAt || order?.created_at;
  return value ? new Date(value).toLocaleDateString('ru-RU') : 'Дата уточняется';
}
export function sellerOrderFilterMatch(order, filter) {
  if (filter === 'all') return true;
  const status = String(sellerOrderStatus(order)).toLowerCase();
  const fulfillment = String(sellerOrderFulfillment(order) || '').toLowerCase();
  if (filter === 'new') return status === 'created' || status === 'new' || fulfillment === 'waiting';
  if (filter === 'processing') return ['assigned', 'collecting', 'assembling', 'processing'].includes(fulfillment) || status === 'assembling';
  return fulfillment === filter || status === filter;
}
export function sellerOrderError(error, action = 'загрузить заказы') {
  const status = error?.response?.status;
  if (status === 401) return 'Сессия продавца истекла. Войдите снова.';
  if (status === 403) return 'У вас нет доступа к заказам продавца.';
  if (status === 404) return 'Заказ не найден. Обновите список.';
  if (status === 409) return 'Состояние заказа уже изменилось. Обновите список и попробуйте снова.';
  if (status >= 500 || !error?.response) return 'Сервер временно недоступен. Попробуйте ещё раз.';
  return `Не удалось ${action}. Попробуйте ещё раз.`;
}
export { fulfillmentLabel, orderStatusLabel };
